import React, {useRef, useState} from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentFolder } from 'app/store/fileItemsSlice';
import TooltipButton from 'app/shared-components/layout/TooltipButton';
import AIChatButton from 'app/shared-components/aichat/AIChatButton';
import FolderHeader from 'app/shared-components/file/FolderHeader';
import PageHeader from 'app/shared-components/layout/PageHeader';
import UploadFileDialog from "app/shared-components/file/UploadFileDialog";
import NewFolderDialog from "app/shared-components/file/NewFolderDialog";

/**
 * Reusable component for file management header functionality
 * @param {Object} props - Component props
 * @param {String} props.rootName - Root folder name
 * @param {Function} props.onSetSidebarOpen - Function to open sidebar
 * @param {string} props.basePath - Base path for files navigation
 * @param {React.ReactNode} props.avatar - Avatar component to display
 */
function FileManagementHeader({ 
  rootName,
  onSetSidebarOpen,
  basePath,
  avatar
}) {
  const folderId = useSelector(selectCurrentFolder);
  const fileInput = useRef();
  const [newFolderDialogOpen, setNewFolderDialogOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const onSelectFile = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    setSelectedFile(files[0]);
  };

  function onCloseFileDialog(){
    setSelectedFile(null);
  }

  function onCloseFolderDialog(){
    setNewFolderDialogOpen(false);
  }

  return (
      <>
        <UploadFileDialog file={selectedFile} onCloseDialog={onCloseFileDialog} />
        <NewFolderDialog open={newFolderDialogOpen} onCloseDialog={onCloseFolderDialog} />
        <PageHeader
            onMenuClick={onSetSidebarOpen ? (ev) => onSetSidebarOpen(true) : undefined}
            avatar={avatar}
            button={
              <>
                <TooltipButton
                    icon="heroicons-outline:folder-plus"
                    onClick={() => setNewFolderDialogOpen(true)}
                    tooltip="Create new Folder"
                />
                <TooltipButton
                    icon="heroicons-outline:document-plus"
                    onClick={() => fileInput.current.click()}
                    tooltip="Upload new file"
                >
                  <input
                      type="file"
                      ref={fileInput}
                      accept="*"
                      hidden
                      onChange={onSelectFile}
                  />
                </TooltipButton>
                <AIChatButton folderId={folderId} />
              </>
            }
        >
          <FolderHeader rootName={rootName} basePath={basePath} />
        </PageHeader>
      </>
  );
}

export default FileManagementHeader;